import React, { useEffect } from "react";

/* ═══════════════════════════════════════════════
   GLOBAL CSS
═══════════════════════════════════════════════ */
const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Plus Jakarta Sans', sans-serif; background: #fafaf8; color: #1a1a1a; }
  a { color: #16a34a; text-decoration: none; }
  a:hover { text-decoration: underline; }
`;

const ARTICLES = [
  {
    num: "1", title: "Objet",
    content: `Les présentes Conditions Générales d'Utilisation ont pour objet de définir les modalités d'accès et d'utilisation de la plateforme TransTiGo, proposant des services de réservation de taxi-brousse, de mise en relation pour covoiturage et de mise en relation pour location de véhicules. La plateforme agit exclusivement en qualité d'intermédiaire technique entre utilisateurs.`,
  },
  {
    num: "2", title: "Définitions",
    items: [
      ["Plateforme", "Application mobile et/ou site TransTiGo"],
      ["Utilisateur", "Toute personne inscrite sur la plateforme"],
      ["Conducteur", "Utilisateur proposant un trajet ou un véhicule"],
      ["Passager", "Utilisateur réservant un trajet"],
      ["Service", "Taxi-brousse, covoiturage ou location"],
    ],
  },
  {
    num: "3", title: "Acceptation des CGU",
    content: "L'inscription et l'utilisation de la plateforme impliquent l'acceptation pleine et entière des présentes CGU.",
  },
  {
    num: "4", title: "Accès à la plateforme",
    content: "L'accès à la plateforme est réservé aux personnes âgées d'au moins 18 ans et disposant de la capacité juridique. TransTiGo se réserve le droit de suspendre ou refuser l'accès en cas de non-respect des CGU.",
  },
  {
    num: "5", title: "Inscription et compte utilisateur",
    content: "L'utilisateur s'engage à fournir des informations exactes et à jour, à ne pas usurper l'identité d'un tiers et à conserver la confidentialité de ses identifiants. Toute activité effectuée via un compte est réputée effectuée par son titulaire.",
  },
  {
    num: "6", title: "Description des services",
    subsections: [
      { title: "Taxi-brousse", content: "Réservation de places dans des véhicules de transport interurbain (soumis aux réalités locales : remplissage, horaires variables)." },
      { title: "Covoiturage", content: "Mise en relation entre conducteurs particuliers et passagers pour un trajet partagé." },
      { title: "Location de véhicules", content: "Mise en relation entre propriétaires de véhicules et locataires. TransTiGo n'est pas propriétaire des véhicules et n'assure pas directement les prestations." },
    ],
  },
  {
    num: "7", title: "Obligations des conducteurs",
    content: "Le conducteur s'engage à détenir un permis valide, disposer d'un véhicule en bon état, respecter la réglementation en vigueur à Madagascar et fournir des informations fiables (trajet, horaires, prix). Dans le cadre de la location, il s'engage à fournir un véhicule conforme et assuré, et à établir les conditions de location avec le locataire.",
  },
  {
    num: "8", title: "Obligations des passagers / locataires",
    content: "L'utilisateur s'engage à respecter les horaires convenus, adopter un comportement respectueux et respecter les conditions fixées par le conducteur.",
  },
  {
    num: "9", title: "Bagages et marchandises",
    content: "Les bagages doivent être déclarés lors de la réservation. Le conducteur peut refuser un bagage excessif ou dangereux. Les bagages restent sous la responsabilité exclusive de leur propriétaire. TransTiGo décline toute responsabilité en cas de perte, vol ou détérioration.",
  },
  {
    num: "10", title: "Paiement et commission",
    content: "Les paiements peuvent être effectués via Mobile Money (MVola, Orange Money, Airtel Money). TransTiGo peut percevoir une commission sur les transactions. Les prix sont affichés avant validation et les modalités de paiement sont précisées lors de la réservation.",
  },
  {
    num: "11", title: "Annulation et remboursement",
    content: "Pour Taxi-brousse : les conditions d'annulation et de remboursement peuvent varier en fonction de la coopérative et du type de tarif choisi. TransTiGo peut intervenir pour faciliter la demande, sans toutefois être responsable des délais de traitement. L'annulation par le passager est possible 2 heures avant le départ. Le remboursement peut être total, partiel ou nul selon les conditions définies au moment de la réservation.",
  },
  {
    num: "12", title: "Retards et conditions locales",
    content: "L'utilisateur reconnaît que les horaires peuvent être indicatifs et que des retards peuvent survenir (routes, météo, remplissage, pannes). TransTiGo ne garantit pas la ponctualité des trajets.",
  },
  {
    num: "13", title: "Responsabilité",
    content: "TransTiGo agit en tant qu'intermédiaire technique. En conséquence, la plateforme ne saurait être tenue responsable des accidents, dommages corporels ou matériels, retards, litiges entre utilisateurs ou pertes de bagages. Chaque utilisateur est seul responsable de ses actes.",
  },
  {
    num: "14", title: "Assurance",
    content: "Les conducteurs sont responsables de leur assurance véhicule et de la couverture des passagers. TransTiGo ne fournit aucune assurance.",
  },
  {
    num: "15", title: "Suspension et résiliation",
    content: "TransTiGo se réserve le droit de suspendre ou supprimer un compte et de refuser l'accès à la plateforme en cas de fraude, comportement dangereux ou non-respect des CGU.",
  },
  {
    num: "16", title: "Données personnelles",
    content: "Les données collectées sont utilisées pour le fonctionnement du service et la mise en relation des utilisateurs. L'utilisateur accepte la collecte et le traitement de ses données. Une politique de confidentialité dédiée complète ces CGU.",
  },
  {
    num: "17", title: "Litiges",
    content: "Les utilisateurs s'engagent à privilégier une résolution amiable. TransTiGo peut intervenir en médiation sans obligation de résultat.",
  },
  {
    num: "18", title: "Droit applicable",
    content: "Les présentes CGU sont régies par le droit Malagasy.",
  },
  {
    num: "19", title: "Modification des CGU",
    content: "TransTiGo se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des mises à jour.",
  },
  {
    num: "20", title: "Contact",
    content: "Pour toute question relative à ces Conditions d'utilisation, contactez-nous par email.",
  },
];

const ConditionsGenerales = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={s.page}>
      <style>{globalCSS}</style>

      {/* Header */}
      <header style={s.header}>
        <a href="/" style={s.logo}>Trans<span style={{ color: "#16a34a" }}>TiGo</span></a>
        <a href="/" style={s.backLink}>← Retour à l'accueil</a>
      </header>

      {/* Hero */}
      <div style={s.hero}>
        <div style={s.heroInner}>
          <div style={s.tag}>Légal</div>
          <h1 style={s.heroTitle}>Conditions Générales<br />d'Utilisation</h1>
          <p style={s.heroDated}>Dernière mise à jour : 20 avril 2026</p>
        </div>
      </div>

      {/* Content */}
      <main style={s.main}>
        <div style={s.container}>
          {/* TOC */}
          <div style={s.toc}>
            <div style={s.tocTitle}>Table des matières</div>
            <div style={s.tocGrid}>
              {ARTICLES.map(a => (
                <a key={a.num} href={`#art-${a.num}`} style={s.tocLink}>
                  <span style={s.tocNum}>{a.num}</span> {a.title}
                </a>
              ))}
            </div>
          </div>

          {/* Articles */}
          <div style={s.articles}>
            {ARTICLES.map(a => (
              <section key={a.num} id={`art-${a.num}`} style={s.article}>
                <div style={s.articleNumRow}>
                  <div style={s.articleNum}>{a.num}</div>
                  <h2 style={s.articleTitle}>{a.title}</h2>
                </div>
                {a.content && <p style={s.articleText}>{a.content}</p>}
                {a.items && (
                  <div style={s.defList}>
                    {a.items.map(([term, def]) => (
                      <div key={term} style={s.defItem}>
                        <span style={s.defTerm}>{term}</span>
                        <span style={s.defDef}>{def}</span>
                      </div>
                    ))}
                  </div>
                )}
                {a.subsections && a.subsections.map(sub => (
                  <div key={sub.title} style={s.subsection}>
                    <div style={s.subTitle}>{sub.title}</div>
                    <p style={s.articleText}>{sub.content}</p>
                  </div>
                ))}
              </section>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={s.footer}>
        <div style={s.footerInner}>
          <div style={s.footerLogo}>Trans<span style={{ color: "#16a34a" }}>TiGo</span></div>
          <div style={s.footerLinks}>
            <a href="/confidentialite" style={s.footerLink}>Politique de confidentialité</a>
            <a href="/conditions" style={s.footerLink}>Conditions générales</a>
            <a href="/contact" style={s.footerLink}>Contact</a>
          </div>
          <div style={s.footerCopy}>© 2025 TransTiGo · Madagascar</div>
        </div>
      </footer>
    </div>
  );
};

const s = {
  page:       { fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#fafaf8", color: "#1a1a1a", minHeight: "100vh" },
  header:     { position: "sticky", top: 0, zIndex: 300, background: "rgba(250,250,248,0.96)", backdropFilter: "blur(20px)", borderBottom: "0.5px solid rgba(0,0,0,0.07)", padding: "0 24px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between" },
  logo:       { fontSize: 18, fontWeight: 800, letterSpacing: -0.5, color: "#1a1a1a", textDecoration: "none" },
  backLink:   { fontSize: 13, color: "#666", textDecoration: "none", fontWeight: 500 },

  hero:       { background: "#1a1a1a", padding: "60px 24px 52px" },
  heroInner:  { maxWidth: 800, margin: "0 auto" },
  tag:        { display: "inline-block", fontSize: 10, fontWeight: 800, letterSpacing: "1.5px", textTransform: "uppercase", color: "#16a34a", background: "rgba(22,163,74,0.12)", border: "0.5px solid rgba(22,163,74,0.3)", padding: "4px 12px", borderRadius: 20, marginBottom: 20 },
  heroTitle:  { fontSize: 36, fontWeight: 800, color: "white", letterSpacing: -1, lineHeight: 1.15, marginBottom: 14 },
  heroDated:  { fontSize: 13, color: "rgba(255,255,255,0.35)", fontWeight: 500 },

  main:       { padding: "52px 24px 80px" },
  container:  { maxWidth: 800, margin: "0 auto", display: "flex", flexDirection: "column", gap: 40 },

  toc:        { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 16, padding: "24px 28px" },
  tocTitle:   { fontSize: 11, fontWeight: 800, letterSpacing: "1px", textTransform: "uppercase", color: "#999", marginBottom: 16 },
  tocGrid:    { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "8px 24px" },
  tocLink:    { fontSize: 12.5, color: "#444", textDecoration: "none", display: "flex", alignItems: "center", gap: 8, padding: "4px 0", transition: "color .15s" },
  tocNum:     { width: 22, height: 22, borderRadius: "50%", background: "#f0fdf4", color: "#16a34a", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, flexShrink: 0 },

  articles:   { display: "flex", flexDirection: "column", gap: 0 },
  article:    { background: "white", border: "0.5px solid #e8e8e4", borderRadius: 14, padding: "28px 32px", marginBottom: 12, scrollMarginTop: 80 },
  articleNumRow: { display: "flex", alignItems: "center", gap: 14, marginBottom: 16 },
  articleNum: { width: 36, height: 36, borderRadius: "50%", background: "#1a1a1a", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, flexShrink: 0 },
  articleTitle: { fontSize: 16, fontWeight: 700, color: "#1a1a1a", letterSpacing: -0.3 },
  articleText: { fontSize: 14, color: "#444", lineHeight: 1.75 },

  defList:    { display: "flex", flexDirection: "column", gap: 10, marginTop: 4 },
  defItem:    { display: "flex", gap: 12, alignItems: "flex-start", background: "#fafaf8", border: "0.5px solid #f0f0ec", borderRadius: 10, padding: "10px 14px" },
  defTerm:    { fontSize: 12.5, fontWeight: 700, color: "#1a1a1a", minWidth: 120, flexShrink: 0 },
  defDef:     { fontSize: 13, color: "#555", lineHeight: 1.6 },

  subsection: { marginTop: 16, paddingTop: 16, borderTop: "0.5px solid #f4f4f0" },
  subTitle:   { fontSize: 13, fontWeight: 700, color: "#16a34a", marginBottom: 8 },

  footer:     { background: "#111", padding: "32px 24px" },
  footerInner:{ maxWidth: 800, margin: "0 auto", display: "flex", flexDirection: "column", gap: 16, alignItems: "flex-start" },
  footerLogo: { fontSize: 16, fontWeight: 800, color: "white", letterSpacing: -0.5 },
  footerLinks:{ display: "flex", gap: 20, flexWrap: "wrap" },
  footerLink: { fontSize: 12, color: "rgba(255,255,255,0.4)", textDecoration: "none" },
  footerCopy: { fontSize: 11, color: "rgba(255,255,255,0.2)" },
};

export default ConditionsGenerales;